import {
  Environment,
  Network,
  RecordSource,
  Store,
  fetchQuery,
  commitMutation,
  commitLocalUpdate,
  QueryResponseCache,
} from 'relay-runtime';

const oneMinute = 60 * 1000;
const cache = new QueryResponseCache({ size: 250, ttl: oneMinute });

function getOptionsWithFiles(operation, variables, uploadables) {
  if (!window.FormData) {
    throw new Error('Uploading files without `FormData` not supported.');
  }
  const body = new FormData();
  body.append('query', operation.text);
  body.append('queryId', operation.id);
  body.append('variables', JSON.stringify(variables));
  Object.keys(uploadables).forEach(filename => {
    // eslint-disable-next-line no-prototype-builtins
    if (uploadables.hasOwnProperty(filename)) {
      body.append(filename, uploadables[filename]);
    }
  });

  return { body };
}

function getOptionsWithoutFiles(operation, variables) {
  const body = JSON.stringify({
    query: operation.text,
    queryId: operation.id,
    variables,
  });

  const headers = {
    Accept: `${process.env.SERVER_DNS}`,
    'Content-Type': 'application/json',
  };

  return { body, headers };
}

const fetchQueryRelay = (
  operation,
  variables,
  cacheConfig,
  uploadables,
  fetchFn,
) => {
  const options = uploadables
    ? getOptionsWithFiles(operation, variables, uploadables)
    : getOptionsWithoutFiles(operation, variables);
  // Start Cache
  const queryID = operation.text;
  const isMutation = operation.operationKind === 'mutation';
  const isQuery = operation.operationKind === 'query';
  const forceFetch = cacheConfig && cacheConfig.force;
  // Try to get data from cache on queries
  const fromCache = cache.get(queryID, variables);
  if (isQuery && fromCache !== null && !forceFetch) {
    return fromCache;
  }
  // End cache
  const fetchLib = fetchFn || fetch;
  const gqlUrl = `${process.env.GRAPHQL_SERVER}/graphql`;
  return new Promise((resolve, reject) => {
    // create wrapper to be able to recursively call function
    function wrapper(maxAttempts, attemptsLeft = maxAttempts) {
      const TIMEOUT = 1000;
      const EXPONENTIAL_BACKOFF =
        TIMEOUT + (maxAttempts - attemptsLeft) ** 2 * 500;
      // create timeout to retry promise if pass timeout
      const timeout = setTimeout(() => {
        if (attemptsLeft > 0) {
          wrapper(maxAttempts, attemptsLeft - 1);
        }
      }, EXPONENTIAL_BACKOFF);
      fetchLib(gqlUrl, {
        method: 'POST',
        credentials: 'include',
        ...options,
        // cacheConfig: { force: false },
      })
        .then(res => res.json())
        .then(jsonPayload => {
          // clear timeout if successful before timeout
          clearTimeout(timeout);
          if (jsonPayload.error) {
            throw new Error(jsonPayload.error);
          }
          // Update cache on queries
          if (isQuery && jsonPayload) {
            cache.set(queryID, variables, jsonPayload);
          }
          // Clear cache on mutations
          if (isMutation) {
            cache.clear();
          }
          return resolve(jsonPayload);
        })
        .catch(err => {
          console.log({ err });
          reject(err);
        });
    }
    const MUTATION_RETRY = 0;
    const QUERY_RETRY = 3;
    // try mutations only once, else retry queries 3 times
    wrapper(isMutation ? MUTATION_RETRY : QUERY_RETRY);
  });
};

/**
 * Creates a set of helper methods for working with REST and/or GraphQL APIs.
 */
const createRelayEnvironment = () => {
  // Configure Relay environment
  const environment = new Environment({
    handlerProvider: null,
    network: Network.create(fetchQueryRelay),
    store: new Store(new RecordSource()),
  });

  return {
    environment,
    fetchQueryRelay,
    fetch: (url, options) =>
      fetch(`${url}`, {
        ...options,
        headers: {
          ...(options && options.headers),
        },
      }),
    fetchQuery: fetchQuery.bind(undefined, environment),
    commitMutation: commitMutation.bind(undefined, environment),
    commitLocalUpdate: commitLocalUpdate.bind(undefined, environment),
  };
};

export default { createRelayEnvironment };
